import React from 'react';

import { colors } from '@styleseat/brand';
import NotificationBanner from '../NotificationBanner';
import { VariousSparklesIcon } from '../../../ui/Icons';
import { PROVIDER_SEARCH_RANK } from '../../../../route-names';

type Notification = {
  type: string;
  provider_id: number;
  creation_time?: number | string | Date;
};

export type NewSearchRankData = {
  allAppts: boolean,
  ncdAppts: boolean,
  reviews: boolean,
};

type NewSRStatsNotificationProps = {
  notification: Notification;
  onCTAClick: () => void;
  newSearchRankData: NewSearchRankData;
};

const NewSRStatsNotification = ({
  notification,
  onCTAClick,
  newSearchRankData,
}: NewSRStatsNotificationProps) => (
  <NotificationBanner
    notification={notification}
    icon={VariousSparklesIcon}
    iconColor={colors.sunshine}
    highlightedText="Metric Unlocked."
    text="Your search ranking has been updated."
    buttonProps={{
      appearance: 'text-light',
      size: 'small',
      text: 'See Updated Score',
      onClick: onCTAClick,
      link: PROVIDER_SEARCH_RANK,
      clickTracking: {
        name: 'pro_notification_new_sr_cta_clicked',
        params: {
          notification_type: 'new_sr_stats_notification',
          provider_id: notification.provider_id,
          allAppts: newSearchRankData.allAppts,
          ncdAppts: newSearchRankData.ncdAppts,
          reviews: newSearchRankData.reviews,
        },
      },
    }}
  />
);

export default NewSRStatsNotification;
